import { h } from 'preact';
import { useEffect, useState } from 'preact/hooks';
import { useShopware } from '../shopware/ShopwareContext';
import type { PaymentMethod } from '../shopware/shopwareApi';

export const AvailablePaymentMethods = () => {
  const { fetchPaymentMethods } = useShopware();
  const [paymentMethods, setPaymentMethods] = useState<PaymentMethod[]>([]);

  useEffect(() => {
    const loadPaymentMethods = async () => {
      try {
        const methods = await fetchPaymentMethods();
        setPaymentMethods(methods);
      } catch (error) {
        console.error('Failed to fetch payment methods:', error);
        setPaymentMethods([]);
      }
    };

    loadPaymentMethods();
  }, [fetchPaymentMethods]);

  if (paymentMethods.length === 0) {
    return null;
  }

  // Filter to only show active payment methods with icons
  const visibleMethods = paymentMethods.filter((pm) => pm.active && pm.media?.url);

  if (visibleMethods.length === 0) {
    return null;
  }

  return (
    <>
      <strong className="small pt-3">Wir akzeptieren:</strong>
      <ul
        className="shopping-cart-overview-payment-methods d-flex flex-wrap gap-2"
        aria-label="Zahlungsmöglichkeiten"
      >
        {visibleMethods.map((paymentMethod, index) => (
          <li
            key={paymentMethod.id || index}
          >
            {paymentMethod.media?.url && (
              <img src={paymentMethod.media.url} alt={(paymentMethod.translated?.name || paymentMethod.name) ?? ''} />
            )}
            <span className="visually-hidden">{paymentMethod.translated?.name || paymentMethod.name}</span>
          </li>
        ))}
      </ul>
    </>
  );
};
